import { render } from "./AccountsIndex.vue?vue&type=template&id=efe59ad0&scoped=true"
import script from "./AccountsIndex.vue?vue&type=script&lang=js"
export * from "./AccountsIndex.vue?vue&type=script&lang=js"

import "./AccountsIndex.vue?vue&type=style&index=0&id=efe59ad0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-efe59ad0"

export default script